/* eslint-disable no-unused-vars */
import { useContext } from "react";
import NewBusiness from "../context/newBusiness/newBusinessContext.jsx";

const useNewBusiness = () => {
  return useContext(NewBusiness);
};

export default useNewBusiness;
